/** FGTS × BMP. */

import { httpV1 as http } from '@/services/api';

const ALT_API_URL = `${process.env.VUE_APP_ALT_BASE_API_URL || process.env.VUE_APP_BASE_API_URL}/v1`;

export async function consult(params) {
  return http.get('/bmp/fgts/balance', { params });
}

export async function simulate(data) {
  return http.post('/bmp/fgts/simulation', data);
}

export async function verify(params) {
  return http.get('/bmp/fgts/proposal', { params });
}

export async function cancel(id) {
  return http.delete(`/bmp/fgts/proposal/${id}`);
}

export async function receipt(id, params) {
  return http.get(`/bmp/fgts/reserve_balance/${id}/generate_receipt`, { params });
}

export async function approve(data) {
  return http.post(`${ALT_API_URL}/bmp/fgts/credit-operation`, data);
}

export async function tryAgain(data) {
  return http.put(`${ALT_API_URL}/bmp/fgts/credit-operation`, data);
}

export async function withdrawalProposal(externalProposalId) {
  return http.post('/bmp/fgts/proposal/reversal', {
    external_proposal_id: externalProposalId,
  });
}

/* Quitação (PayoffCharges) */
export async function listBankSlips(params) {
  return http.get('/bmp/fgts/payoff/bank-slips', { params });
}

export async function listOpenInstallments(params) {
  return http.get('/bmp/fgts/payoff/installments', { params });
}

export async function generateBankSlip(data) {
  return http.post('/bmp/fgts/payoff/generate-bank-slip', data);
}

export async function cancelBankSlip(params) {
  return http.delete('/bmp/fgts/payoff/bank-slip', { params });
}
